<template>
  <div :class="[`${baseClass}-wrapper`]">
    <div v-show="numLastPage > 1" :class="[baseClass]">
      <!-- First Page -->
      <a @click="loadPage('first')" :class="[baseItemClass, isOnFirstPage ? disabledItemClass : '']">
        <svgicon class="ks-icon-size-xs ks-icon-rotate-left" icon="ks-icon-double-chevron" />
      </a>

      <!-- Previous Page -->
      <a @click="loadPage('prev')" :class="[baseItemClass, isOnFirstPage ? disabledItemClass : '']">
        <svgicon class="ks-icon-size-xs ks-icon-rotate-left" icon="ks-icon-chevron" />
      </a>

      <template v-if="notEnoughPages">
        <template v-for="n in numLastPage">
          <a @click="loadPage(n)" :key="n" :class="[baseItemClass, isCurrentPage(n) ? activeItemClass : '']" >
            <template v-if="loadingData[n]">
              <div class="ks-spinner ks-spinner--dark"></div>
            </template>
            <template v-else>
              {{ n }}
            </template>
          </a>
        </template>
      </template>

      <!-- Page Numbers -->
      <template v-else>
        <template v-for="n in windowSize">
          <a @click="loadPage(windowStart + n - 1)" :key="n"
            :class="[baseItemClass, isCurrentPage(windowStart + n - 1) ? activeItemClass : '']">
            <template v-if="loadingData[windowStart + n - 1]">
              <div class="ks-spinner ks-spinner--dark"></div>
            </template>
            <template v-else>
              {{ windowStart + n - 1}}
            </template>
          </a>
        </template>
      </template>

      <!-- Next Page -->
      <a @click="loadPage('next')" :class="[baseItemClass, isOnLastPage ? disabledItemClass : '']">
        <svgicon class="ks-icon-size-xs ks-icon-rotate-right" icon="ks-icon-chevron" />
      </a>

      <!-- Last Page -->
      <a @click="loadPage('last')" :class="[baseItemClass, isOnLastPage ? disabledItemClass : '']">
        <svgicon class="ks-icon-size-xs ks-icon-rotate-right" icon="ks-icon-double-chevron" />
      </a>

      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import svgicon from 'vue-svgicon'
import 'Components/icons'
import GenericStoreCoordinatorService from 'Services/genericStoreCoordinator/Service'

export default {
  name: 'generic-store-backed-pagination',
  components: { svgicon },
  props: {
    uuid: {
      type: String,
      required: true,
    },
  },
  fromMobx: {
    paginationData () {
      return this.coordinator.paginationData
    },
    loadingData () {
      return this.coordinator.loadingData
    },
  },
  methods: {
    loadPage (pageNum) {
      return this.coordinator.goToPage(pageNum)
    },
    isCurrentPage (page) {
      return page === this.currentPageNum
    },
  },
  computed: {
    windowSize () {
      return this.onEachSide * 2 + 1
    },
    windowStart () {
      if (this.currentPageNum <= this.onEachSide) {
        return 1
      } else if (this.currentPageNum >= (this.numLastPage - this.onEachSide)) {
        return this.numLastPage - this.onEachSide * 2
      }

      return this.currentPageNum - this.onEachSide
    },
    notEnoughPages () {
      return this.numLastPage < (this.onEachSide * 2) + 4
    },
    isOnFirstPage () {
      // The current page equal to the first page on the server
      return this.currentPageNum === 1
    },
    isOnLastPage () {
      // The current page equal to the last page on the server
      return this.currentPageNum === this.numLastPage
    },
    numLastPage () {
      // What is the number of the last page on the server?
      return this.paginationData && this.paginationData.last_page
    },
    currentPageNum () {
      // The current page number being viewed
      return this.paginationData && this.paginationData.current_page
    },
  },
  data () {
    const baseClass = 'pagination'
    const baseItemClass = `${baseClass}__item`
    const activeItemClass = `${baseItemClass}--active`
    const disabledItemClass = `${baseItemClass}--disabled`

    return {
      baseClass,
      baseItemClass,
      activeItemClass,
      disabledItemClass,
      onEachSide: 2,
      coordinator: GenericStoreCoordinatorService.getById(this.uuid),
    }
  },
}
</script>

<style lang="scss">
@use "~Styles/variables";

  @media screen and (max-width: 768px) {
    .pagination-wrapper {
      margin-bottom: variables.$task-list-header-height;
    }
  }
</style>
